export const OPEN_SWITCHER = 'OPEN_SWITCHER';
export const CLOSE_SWITCHER = 'CLOSE_SWITCHER';
